// Source of truth for the pricing comparison table.
// Values can be:
//   true       -> shown as a green Check icon
//   false      -> shown as a muted dash / X
//   "string"   -> shown as text (e.g. "40 accounts", "1–2 hours")
//
// Row labels & group headings are resolved via i18n keys in `content.pricingCompare`.

export const PRICING_TIERS = [
  { key: "launch",    tk: "pricing.launch",    highlighted: false },
  { key: "growth",    tk: "pricing.growth",    highlighted: false },
  { key: "scale",     tk: "pricing.scale",     highlighted: true  },
  { key: "dominance", tk: "pricing.dominance", highlighted: false },
];

export const PRICING_COMPARE = [
  {
    groupKey: "platformAccess",
    rows: [
      { key: "meta",           launch: "1 platform", growth: true,        scale: true,        dominance: true },
      { key: "google",         launch: "1 platform", growth: true,        scale: true,        dominance: true },
      { key: "tiktok",         launch: "1 platform", growth: true,        scale: true,        dominance: true },
      { key: "linkedin",       launch: false,        growth: true,        scale: true,        dominance: true },
      { key: "native",         launch: false,        growth: false,       scale: true,        dominance: true },
      { key: "multiPlatform",  launch: false,        growth: true,        scale: true,        dominance: true },
    ],
  },
  {
    groupKey: "accountsProvisioning",
    rows: [
      { key: "monthlyLimit",     launch: "5 accounts",  growth: "20 accounts", scale: "40 accounts", dominance: "Unlimited" },
      { key: "fastTrack",        launch: false,         growth: false,         scale: false,         dominance: true },
      { key: "budgetAllocation", launch: false,         growth: true,          scale: true,          dominance: true },
      { key: "onboardingGuide",  launch: false,         growth: true,          scale: true,          dominance: true },
    ],
  },
  {
    groupKey: "supportSla",
    rows: [
      { key: "responseTime",   launch: "24 hours",       growth: "12 hours",             scale: "~8 hours",              dominance: "1–2 hours" },
      { key: "supportChannel", launch: "Dashboard chat", growth: "WhatsApp / Telegram",  scale: "WhatsApp / Telegram",   dominance: "Priority WhatsApp" },
      { key: "accountManager", launch: false,            growth: false,                  scale: true,                    dominance: true },
      { key: "adsExpert",      launch: false,            growth: false,                  scale: false,                   dominance: true },
    ],
  },
  {
    groupKey: "strategyOptimization",
    rows: [
      { key: "creativeSupport", launch: false, growth: false, scale: false, dominance: true },
      { key: "adsConsultancy",  launch: false, growth: false, scale: false, dominance: "4 hrs / mo" },
      { key: "campaignReviews", launch: false, growth: false, scale: false, dominance: true },
      { key: "aiWorkflow",      launch: false, growth: false, scale: false, dominance: true },
    ],
  },
  {
    groupKey: "reportingCompliance",
    rows: [
      { key: "complianceDocs",  launch: true,       growth: true,       scale: true,       dominance: true },
      { key: "urlApprovals",    launch: "Required", growth: "Standard", scale: "Standard", dominance: "Fast-track" },
      { key: "customReports",   launch: false,      growth: false,      scale: false,      dominance: true },
    ],
  },
];
